import { FleekError } from './FleekError';

type PrivateGatewayNameInvalidErrorOptions = {
  name: string;
};

export class PrivateGatewayNameInvalidError extends FleekError<PrivateGatewayNameInvalidErrorOptions> {
  public name = 'PrivateGatewayNameInvalidError';

  toString = () => `The private gateway name ${this.data.name} is invalid.`;
}
